import { createSlice } from '@reduxjs/toolkit'
import Config from '../../Core/Config'

export const SET_SELECTED_TEST_CELLS = 'ui/testcells/setSelected'
export const UNSELECT_TEST_CELL = 'ui/testcells/unselect'
export const ACTIVATE_SHORTCUT = 'ui/testcells/activateShortcut'
export const DISACTIVATE_SHORTCUT = 'ui/testcells/disactivateShortcut'

const testCellsUiSlice = createSlice({
  name: 'testCells',
  initialState: {
    selectedTestCells: [],
    activeShortcut: null,
    menu: {
      expanded: Config.ui.defaultExpandedRightMenu,
    },
  },
  reducers: {
    init: (state) => {
      return { ...state, initing: true }
    },
    setSelectedTestCells: (state, action) => {
      state.selectedTestCells = action.payload
    },
    unselectTestCell: (state, action) => {
      state.selectedTestCells = state.selectedTestCells.filter((tc) => tc.id !== action.payload.id)
    },
    activateShortcut: (state, action) => {
      state.activeShortcut = action.payload
    },
    disactivateShortcut: (state) => {
      state.activeShortcut = null
    },
    toggleMenuExpanded: (state) => {
      state.menu.expanded = !state.menu.expanded
    },
  },
})

export const { setSelectedTestCells, unselectTestCell, activateShortcut, disactivateShortcut, toggleMenuExpanded } =
  testCellsUiSlice.actions
export default testCellsUiSlice.reducer

export const selectSelectedTestCells = (state) => state.ui.testCells.selectedTestCells
export const selectActiveShorcut = (state) => state.ui.testCells.activeShortcut
export const selectMenuExpanded = (state) => state.ui.testCells.menu.expanded
